document.addEventListener("DOMContentLoaded", () => {
  const variantInput = document.querySelector(
    "variant-selects fieldset input[checked]"
  );
  const product = JSON.parse(variantInput.dataset.product);
  const initialCareInstructions = variantInput.dataset.careInstructions;

  const updateCareInstructions = (careInstructions) => {
    if (!careInstructions) return;

    const summaryInstructionsBlock = Array.from(
      document.querySelectorAll(".h4.accordion__title.inline-richtext")
    ).find((h2) => h2.textContent.trim() === "Care Instructions").parentElement
      .parentElement;

    if (!summaryInstructionsBlock)
      throw new Error(
        "Error on updating Care Instructions: Either summary care instructions block or one of its childs wasn't found."
      );

    const accordion = summaryInstructionsBlock.nextElementSibling;
    const paragraph = accordion.querySelector("p");

    paragraph.innerHTML = careInstructions;
  };

  // const updateProductImages = (product) => {
  //   const mainImage = document.querySelector(
  //     ".product__media.media.media--transparent img"
  //   );
  //   const productImages = document.querySelectorAll(
  //     ".product__media-item.grid__item.slider__slide div modal-opener .product__media img"
  //   );

  //   const productZoomImages = document.querySelectorAll(
  //     "product-modal div div img"
  //   );

  //   // Change main image
  //   if (product && product.featured_image) {
  //     const featuredImageURL = product.featured_image;

  //     // Set the src attribute for the image
  //     mainImage.src = featuredImageURL;
  //     // Create srcset attribute dynamically to handle different sizes
  //     mainImage.srcset = `
  //           ${featuredImageURL}&width=246 246w,
  //           ${featuredImageURL}&width=493 493w,
  //           ${featuredImageURL}&width=600 600w,
  //           ${featuredImageURL}&width=713 713w,
  //           ${featuredImageURL}&width=823 823w,
  //           ${featuredImageURL}&width=990 990w,
  //           ${featuredImageURL}&width=1100 1100w,
  //           ${featuredImageURL}&width=1206 1206w,
  //           ${featuredImageURL}&width=1346 1346w,
  //           ${featuredImageURL}&width=1426 1426w,
  //           ${featuredImageURL}&width=1646 1646w,
  //           ${featuredImageURL}&width=1946 1946w`;

  //     // Set sizes attribute to optimize image loading based on viewport
  //     mainImage.sizes =
  //       "(min-width: 1200px) 715px, (min-width: 990px) calc(65.0vw - 10rem), (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw / 1 - 4rem)";
  //   } else {
  //     console.error(
  //       "Variant change event triggered, but no product image found."
  //     );
  //   }
  //   // Change Gallery images
  //   if (productImages) {
  //     productImages.forEach((image, index) => {
  //       const imageUrl = product.images[index];
  //       image.src = imageUrl;
  //       image.srcset = `
  //           ${imageUrl}&width=246 246w,
  //           ${imageUrl}&width=493 493w,
  //           ${imageUrl}&width=600 600w,
  //           ${imageUrl}&width=713 713w,
  //           ${imageUrl}&width=823 823w,
  //           ${imageUrl}&width=990 990w,
  //           ${imageUrl}&width=1100 1100w,
  //           ${imageUrl}&width=1206 1206w,
  //           ${imageUrl}&width=1346 1346w,
  //           ${imageUrl}&width=1426 1426w,
  //           ${imageUrl}&width=1646 1646w,
  //           ${imageUrl}&width=1946 1946w`;
  //     });
  //   }

  //   //Change Zoom Images
  //   if (productZoomImages) {
  //     productZoomImages.forEach((image, index) => {
  //       const imageUrl = product.images[index];
  //       image.src = imageUrl;
  //       image.srcset = `
  //           ${imageUrl}&width=246 246w,
  //           ${imageUrl}&width=493 493w,
  //           ${imageUrl}&width=600 600w,
  //           ${imageUrl}&width=713 713w,
  //           ${imageUrl}&width=823 823w,
  //           ${imageUrl}&width=990 990w,
  //           ${imageUrl}&width=1100 1100w,
  //           ${imageUrl}&width=1206 1206w,
  //           ${imageUrl}&width=1346 1346w,
  //           ${imageUrl}&width=1426 1426w,
  //           ${imageUrl}&width=1646 1646w,
  //           ${imageUrl}&width=1946 1946w`;
  //     });
  //   }

  //   // Add To Cart button
  //   const addToCartButton = document.querySelector(
  //     ".product-form__submit.button span"
  //   );
  //   if (addToCartButton) {
  //     // addToCartButton.textContent = `Add to cart - $${product.price / 100}`;
  //   }
  // };

  // updateProductImages(product);
  updateCareInstructions(initialCareInstructions);

  changeSwatchesAvailability(false);
  document.addEventListener("variantChange", (event) => {
    // if (event.detail.target.name.replace(/\n/g, "") == "Color-1") {
    //   changeSwatchesAvailability(true);
    // }

    const targetProduct = event.detail.product;

    if (!targetProduct) return;
    const targetProductCareInstructions =
      event.detail.target.dataset.careInstructions;
    if (!targetProductCareInstructions) return;
    updateCareInstructions(targetProductCareInstructions);
  });
});

function updateVariantQuery(newVariantId) {
  // Get the current URL
  const currentUrl = new URL(window.location.href);

  // Update the 'variant' parameter
  currentUrl.searchParams.set("variant", newVariantId);

  // Update the browser's address bar without reloading the page
  window.history.replaceState({}, "", currentUrl);
}

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

const changeSwatchesAvailability = async (colorChanged = false) => {
  const selectedOptionsElement = document.querySelectorAll(
    "fieldset input[checked]"
  );
  const availabilityButtons = document.querySelectorAll('input[name^="Size-"]');
  const allWidthButtons = document.querySelectorAll('input[name^="Width-"]');
  const productElement = document.querySelector(
    ".product-form__input--swatch input[checked]"
  );

  if (!productElement) return;

  const productAttr = productElement.dataset.product;
  const product = JSON.parse(productAttr);
  let selectedOptions = [];

  selectedOptionsElement.forEach((e, i) => {
    if (i > 2) return;
    selectedOptions.push([e.name.replace(/\n/g, "").split("-")[0], e.value]);
  });
  const optionsObject = Object.fromEntries(selectedOptions);
  const filteredVariants = product.variants.filter(
    (e) => e.option1 === optionsObject.Color && e.option3 == optionsObject.Width
  );

  // Check if there are no available variants on the current options selection
  const noAvailableVariants = !filteredVariants.some((v) => v.available);

  for (wButton of allWidthButtons) {
    const buttonValue = wButton.value;
    const variantsOfWidth = product.variants.filter(
      (v) => v.option3.toLowerCase() === buttonValue.toLowerCase()
    );
    const atLeastOneAvailable = variantsOfWidth.some((v) => v.available);
    // Disable the width button if there are no available variants for that width
    if (!atLeastOneAvailable) {
      wButton.classList.add("disabled");
      wButton.disabled = true;
    } else {
      wButton.classList.remove("disabled");
      wButton.disabled = false;
    }

    // If the current selected width dont have available variants, select the first available width
    if (noAvailableVariants) {
      if (wButton.disabled && wButton.checked) {
        const firstAvailableWidth = [...allWidthButtons].find(
          (b) => !b.disabled && b.value !== buttonValue
        );
        if (firstAvailableWidth) {
          firstAvailableWidth.click();
          return;
        }
      }
    }
  }

  // Example usage: Set a new variant ID

  availabilityButtons.forEach((input, i) => {
    if (filteredVariants[i] && filteredVariants[i].available) {
      input.classList.remove("disabled");
    } else {
      input.classList.add("disabled");
    }
  });

  selectedOptions = [];
};

window.changeSwatchesAvailability = changeSwatchesAvailability;
